import {createAction, props} from "@ngrx/store";
import {AppPermissions, PermissionPackageDto, TokenDto} from "@server-models";
import {TUserFeatureFlags} from "@shared/stores/permissions/store/shared-permissions.state";

export const getPermissions = createAction(
  '[Shared Permissions] Get Permissions',
  props<{ token: TokenDto }>()
);

export const getPermissionsSuccess = createAction(
  '[Shared Permissions] Get Permissions Success',
  props<{ packages: PermissionPackageDto[]; userPermissions: AppPermissions[]; userFeatureFlags: TUserFeatureFlags }>()
);

export const getPermissionsFail = createAction(
  '[Shared Permissions] Get Permissions Fail',
  props<{ error: Error }>()
);

